import {useQuery} from 'react-query'
import {CmsServiceEditModalForm} from './CmsServiceEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_dashboard/helpers'
import {useListView} from '../core/ListViewProvider'
import { getOneById } from '../../../../services/common_requests'
import { initialCmsService } from '../core/_models'

const CmsServiceEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: CmsService,
    error,
  } = useQuery(
    `${QUERIES.CMS_SERVICES_LIST}-CmsService-${itemIdForUpdate}`,
    () => {
      return getOneById(itemIdForUpdate,"/cms-services")
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <CmsServiceEditModalForm isCmsServiceLoading={isLoading} CmsService={{...initialCmsService, _id: undefined}} />
  }

  if (!isLoading && !error && CmsService) {
    return <CmsServiceEditModalForm isCmsServiceLoading={isLoading} CmsService={CmsService} />
  }

  return null
}

export {CmsServiceEditModalFormWrapper}
